import { createSlice } from '@reduxjs/toolkit';
import { LocationsState } from './locations.state';
import { GetStatesByRegion } from './thunks/get-states-by-region.thunk';

const initialState: LocationsState = {
    statesByRegion: [],
    isLoading: false,
    status: '',
    error: '',
};

const locationsSlice = createSlice({
    name: 'locations',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(GetStatesByRegion.pending, (state) => {
            state.isLoading = true;
            state.status = 'loading';
            state.error = '';
        });
        builder.addCase(GetStatesByRegion.fulfilled, (state, action) => {
            state.isLoading = false;
            state.status = 'success';
            state.statesByRegion = action.payload.statesByRegion;
        });
        builder.addCase(GetStatesByRegion.rejected, (state, action) => {
            state.isLoading = false;
            state.status = 'failed';
            state.error = action.error.message;
        });
    },
});

export default locationsSlice.reducer;
